/**
 * @generated SignedSource<<886868e2ef250ce35d7ffad817140f0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type liveArticleArticle$data = {
  readonly entityId: string;
  readonly entityUuid: string;
  readonly " $fragmentSpreads": FragmentRefs<"contentLiveArticleArticle" | "liveUpdateSwitchLiveArticleArticle" | "newsletterWidgetLiveArticleArticle" | "reduceWhitespaceByAvailableSpaceArticle">;
  readonly " $fragmentType": "liveArticleArticle";
};
export type liveArticleArticle$key = {
  readonly " $data"?: liveArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"liveArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "liveArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentLiveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "liveUpdateSwitchLiveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "newsletterWidgetLiveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "reduceWhitespaceByAvailableSpaceArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "dee83b37049a8e6d94ecbb43719d6440";

export default node;
